// countries.js
const countries = ['Tunis - Tunisie', 'Dubai - UAE', 'Casablanca - Maroc'];

export default countries;
